// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginimage{
    width: '100%';
    height: '100%'; 
    padding: 'inherit'; 
    border-radius: "20px" ;
}


@media (max-width: 720px) {
    .loginimage {
        width: 100%;
        height: auto;
        padding: inherit;
        border: 0px;
        border-radius: 20px;
        
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;;AAGA;IACI;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,WAAW;QACX,mBAAmB;;IAEvB;EACF","sourcesContent":[".loginimage{\r\n    width: '100%';\r\n    height: '100%'; \r\n    padding: 'inherit'; \r\n    border-radius: \"20px\" ;\r\n}\r\n\r\n\r\n@media (max-width: 720px) {\r\n    .loginimage {\r\n        width: 100%;\r\n        height: auto;\r\n        padding: inherit;\r\n        border: 0px;\r\n        border-radius: 20px;\r\n        \r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
